import axios from "axios";
import Cookies from "js-cookie";

const fetchData = async () => {
  const response = await axios.get("/api/meta/general");

  const { data } = response;

  data.ianaTimeZoneId && Cookies.set("timezone", data.ianaTimeZoneId);

  return response.data;
};

const logoUrl = (isDefault: boolean = true) =>
  `/api/meta/${isDefault ? "noteserve" : "company"}/logo.svg`;

const MetaService = {
  fetchData,
  logoUrl,
};

export default MetaService;
